import { render, staticRenderFns } from "./mptcp.vue?vue&type=template&id=1ea91e15&scoped=true&"
import script from "./mptcp.vue?vue&type=script&lang=js&"
export * from "./mptcp.vue?vue&type=script&lang=js&"
import style0 from "./mptcp.vue?vue&type=style&index=0&id=1ea91e15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea91e15",
  null
  
)

export default component.exports